import React from 'react';

import { CircularProgress } from '@mui/material';

import EmptyBox from './EmptyBox';

export default class EmptyLoadingBox extends React.Component {
    render() {
        const component = this.props.component || EmptyBox;

        return React.createElement(
            component,
            {
                style: this.props.style,
                className:
                    this.props.className ||
                    (this.props.fullWidth ? 'vulners-landing-tab-full-width flex1' : 'vulners-landing-tab flex1')
            },
            React.createElement(CircularProgress)
        );
    }
}
